export class ElearningResult {
    id: number;
    firstname: string;
    lastname: string;
    courseFullName: string;
    category: string;
    courseID: number;
    categoryID: number;
    gradeFinal: number;
    email: string;
    externalId: number;
    organisationName: string;
    dioceseId: number;
    dioceseName: string;
}


// WEBPACK FOOTER //
// ./src/app/models/elearningResult.ts